import React, { useContext } from "react";
import styled from "styled-components";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { SvgIcon, Typography } from "@mui/material";
import { Title } from "components/Typography";
import { LanguageContext } from "contexts/language.context";
import { Translate } from "utils/translate";

const Row = styled(Typography)`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem !important;
  svg {
    margin-right: 0.5rem;
  }
`;

const Contact = () => {
  const { language } = useContext(LanguageContext);
  const { email, phone, whatsapp } = Translate(language, ["CONTACT", "data"]);
  return (
    <div>
      <Title variant="h5">{Translate(language, ["CONTACT", "title"])}</Title>
      <Row sx={{ marginBottom: "0.5rem" }}>
        <SvgIcon component={MarkEmailReadIcon} /> {email}
      </Row>
      <Row>
        <SvgIcon component={WhatsAppIcon} />
        {whatsapp || "N/A"}
      </Row>
      <Row>
        <SvgIcon component={LocalPhoneIcon} />
        {phone || "N/A"}
      </Row>
    </div>
  );
};

export default Contact;
